import React from "react";
import { useNavigate } from "react-router-dom";
import { useDemoModal } from "../hooks/useDemoModal";

export default function FinalCTA() {
    const navigate = useNavigate();
    const { openModal } = useDemoModal();
    return (
        <section className="vy-dark vy-section" data-testid="landing-final-cta">
            <div className="vy-container" style={{ position: "relative", zIndex: 1, textAlign: "center" }}>
                <div className="vy-reveal">
                    <div className="vy-kicker">&gt; end.of.tour</div>
                    <h2
                        className="vy-serif-i"
                        style={{
                            fontSize: "3.4rem", lineHeight: 1.05, marginTop: 16,
                            color: "var(--vy-paper)", letterSpacing: -0.01,
                        }}
                        data-testid="final-cta-headline"
                    >
                        Ready to see your{" "}
                        <span className="vy-serif" style={{ color: "var(--vy-gold)", fontStyle: "normal" }}>books breathe</span>?
                    </h2>
                    <p style={{
                        marginTop: 18, color: "rgba(246,242,235,0.75)", fontSize: 16, maxWidth: 560, margin: "18px auto 0",
                    }}>
                        Free forever for teams under 5. No card. No sales call. Import your existing books in one click.
                    </p>
                    <div style={{ marginTop: 32, display: "flex", justifyContent: "center", gap: 12, flexWrap: "wrap" }}>
                        <button
                            type="button"
                            className="vy-btn vy-btn-primary"
                            onClick={() => navigate("/signup")}
                            data-testid="final-cta-primary"
                        >
                            Start free · no card
                            <span aria-hidden style={{ marginLeft: 4 }}>→</span>
                        </button>
                        <a
                            href="#book-demo"
                            onClick={(e) => { e.preventDefault(); openModal(); }}
                            className="vy-btn vy-btn-ghost-light"
                            data-testid="final-cta-demo"
                        >
                            Book a 20-min demo
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
